<div class="form-wrapper">
    <app-dyn-form #dynForm class="form" [horizontalMode]="horizontalMode" [key]="formKey" [title]="title"
        [model]="isEditMode?data:displayData" [showTitle]="false" [isEditMode]="isEditMode" [autoSave]="autoSave"
        [updatedOnKey]="updatedOnKey" (result)="onSubmitted($event)" (valueChanged)="changed($event)">
    </app-dyn-form>

</div>